/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import type { Image } from '@modules/cui/ProductGif/types'
import CuiProductGif from '@modules/cui/ProductGif'

import DeploymentGettingStartedVideo from './DeploymentGettingStartedVideo'

import type { FC } from 'react'

type DeploymentGettingStartedMediaProps = {
  isAnyAdminConsole: boolean
}

const DeploymentGettingStartedMedia: FC<DeploymentGettingStartedMediaProps> = ({
  isAnyAdminConsole,
}) => {
  if (isAnyAdminConsole) {
    return <CuiProductGif images={getProductImages()} />
  }

  return <DeploymentGettingStartedVideo />
}

function getProductImages(): Image[] {
  const staticImgPrefix = '/static/images/ece-waiting-state'
  return [
    { alt: 'Enterprise Search', src: `${staticImgPrefix}-1.gif`, interval: 17000 },
    { alt: 'Observability', src: `${staticImgPrefix}-2.gif`, interval: 18000 },
    { alt: 'Security', src: `${staticImgPrefix}-3.gif`, interval: 20000 },
  ]
}

export default DeploymentGettingStartedMedia
